<div class="menu-indice">Gestión de Constancias de {{tipo_participante}} / Registro de constancia</div>
<mdb-card>
    <mdb-card-body>
        <div class="form-row align-items-center">
            <div class="form-group col-md-6">
                <div class="md-form mt-0 mb-0">
                    <input type="text" id="txt_nombre" maxlength="100" [(ngModel)]="txt_nombre" class="form-control" mdbInput>
                    <label for="txt_nombres">Nombre</label>
                </div>
            </div>
            <div class="form-group col-md-1">
              Estado:
          </div>
          <div class="form-group col-md-3">
                    <select class="browser-default custom-select" [(ngModel)]="cboEstado">
                    <option value="0" selected>Todos</option>
                    <option *ngFor="let listEstado of listEstado" [value]="listEstado.c_tabla">{{listEstado.x_valor}}</option>
                    </select>
          </div>
        </div>
        <div class="form-row d-flex justify-content-center">
          <!-- <div class="form-group col-md-12 d-flex justify-content-left"></div> -->
              <div class="form-group col-md-2">
                <button mdbBtn type="button" id="btnBuscar"  (click)="onBuscar()"  size="sm" color="blue" mdbWavesEffect>
                <mdb-icon fas icon="search" class="mr-1"></mdb-icon>Buscar</button>
              </div>
              <div class="form-group col-md-2">
                <button mdbBtn type="button" id="btnNuevo" size="sm" (click)="onNuevo()" color="teal" mdbWavesEffect>
                <mdb-icon fas icon="file-medical" class="mr-1"></mdb-icon>Nuevo</button>
              </div>
        </div>
    </mdb-card-body>
  </mdb-card>
  <br/>
  <mdb-card>
    <div class="table-responsive">
    <table mdbTable hover="true" class="table">
        <thead>
          <tr>
            <th scope="col">Nro</th>
            <th scope="col">Formato</th>
            <th scope="col">Curso</th>
            <th scope="col">Estado</th>
            <th scope="col">Editar</th>
            <th scope="col">{{tipo_participante}}</th>
            <th scope="col">Culminar</th>
          </tr>
        </thead>
        <tbody>
          <tr mdbTableCol *ngFor="let listConst of listConstancias | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize ;let i = index">
            <th>{{i + 1+ (page-1)*10}}</th>
            <th style="text-align: center;">{{listConst.x_titulo}}<br>
               <span>{{listConst.f_constancia}}</span>
            </th>
            <td>{{listConst.x_curso}}</td>
            <td>{{listConst.x_estado}}</td>
            <td>
              <button type="button" (click)="onEditar(listConst)" color="blue" outline="true" class="btn-sm" mdbWavesEffect mdbBtn>
                <mdb-icon fas [icon]="listConst.c_estado == 32 || listConst.c_estado == 33 ? 'eye' : 'edit'" size="lg"></mdb-icon>
              </button>
              </td>
            <td><button type="button" (click)="onVerParticipante(listConst)" color="blue" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="users" size="lg"></mdb-icon></button></td>
            <td>
              <button type="button" [disabled]="listConst.c_estado == 33 ? true : null" [color]="listConst.c_estado == 33 ? 'green':'light-blue'" (click)="onCulminar(listConst)"  outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="check-double" size="lg"></mdb-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
        <div class="text-center">

          <ngb-pagination [maxSize]=3 [(page)]="page" class="d-flex justify-content-center"
            [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listConstancias.length">
          </ngb-pagination>

        </div>
  </mdb-card>
<br>

